import Api from '../api';

export const getUsageMapping = async () => {
  const response = await Api.get(`/api/controle_crm/usage_mapping`);

  return response.data;
};
